import { fetchOrder } from 'actions/OrderActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useOrder(orderId: string | undefined): [App.Order | undefined, boolean, any] {
  const dispatch = useAppDispatch()
  const order = useAppSelector(state => orderId ? state.orders.orders[orderId] : undefined)
  const fetching = useAppSelector(state => orderId ? state.orders.ordersFetching[orderId] : false)
  const error = useAppSelector(state => orderId ? state.orders.orderErrors[orderId] : undefined)

  useEffect(() => {
    if (orderId) {
      dispatch(fetchOrder(orderId))
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId])

  return [order, fetching, error]
}

export default useOrder
